import { useCallback } from 'react';
import { useMessage } from '@/shared/hooks/useMessage';
import type { ActionFlowRequestDTO, ActionFlowRequestSearch } from '../types/request';
import {useGetRequests} from "@/shared/api/client/action-flow";

/**
 * Hook to fetch action flow requests with a specified status
 *
 * @param searchParams - Search parameters including status
 * @returns Object containing requests data, loading state, error and refetch function
 */
export const useRequests = (searchParams: ActionFlowRequestSearch) => {
    const message = useMessage();

    const {
        data: response,
        isLoading,
        error,
        refetch
        // @ts-ignore
    } = useGetRequests(searchParams, {
        query: {
            enabled: true,
            // @ts-ignore
            onError: (error) => {
                message.error('Failed to fetch requests');
            }
        }
    });

    return {
        requests: response?.data || [],
        isLoading,
        error,
        refetch
    };
};


